import {
  AtomVideoErrors,
  AtomVideoSocket,
} from "../../../store/videoSocket.store";

import { AtomSelectedRace } from "../../../store/races/races.store";
import Video from "./video.container";
import styles from "./video.module.scss";
import { useRecoilState, useRecoilValue } from "recoil";
import { FaTimes } from "react-icons/fa";

type Props = {
  maxWidth?: number;
  className?: string;
  hide?: boolean;
};

const VideoWrapper = (p: Props) => {
  const race = useRecoilValue(AtomSelectedRace);
  const [videoSocket, setVideoSocket] = useRecoilState(AtomVideoSocket);
  const videoError = useRecoilValue(AtomVideoErrors);

  if (!race) return null;
  if (p.hide) return null;

  return (
    <>
      {videoSocket && (
        <div>
          <div className={`${styles.wrapper} ${p.className}`}>
            <button
              onClick={() => setVideoSocket(null)}
              className={styles.closeBtn}
            >
              <FaTimes />
            </button>
            <Video websocket={videoSocket}></Video>
            <div className={styles.error}>{videoError}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoWrapper;
